<template>
  <div>
    <div v-if="workShow === 'list'">
      <div class="commonFilter">
        <div class="card-container">
          <div class="card-content">
            <Form ref="pageParams" :model="pageParams" :label-width="90" label-position="right">
              <div class="platformSearch">
                <!-- 状态 -->
                  <Form-item :label="$t('common.status') + '：'">
                    <keep-alive>
                      <Button-group>
                        <template v-for="(item, index) in isValidList">
                          <Button v-if="item.selected" type="primary" @click="getIsValidStatus(index,item.id)" :key="index">{{item.title}}</Button>
                          <Button v-if="!item.selected" @click="getIsValidStatus(index,item.id)" :key="index">{{item.title}}</Button>
                        </template>
                      </Button-group>
                    </keep-alive>
                  </Form-item>
                <!-- 类型 -->
                  <Form-item :label="$t('logisticsProvider.channelType') + '：'">
                    <keep-alive>
                      <Button-group>
                        <template v-for="(item, index) in channelTypeList">
                          <Button v-if="item.selected" type="primary" @click="getchannelType(index, item.id)" :key="index">{{item.title}}</Button>
                          <Button v-if="!item.selected" @click="getchannelType(index, item.id)" :key="index">{{item.title}}</Button>
                        </template>
                      </Button-group>
                    </keep-alive>
                  </Form-item>
                  <Row>
                    <Col span="5">
                      <Form-item :label="$t('logisticsProvider.channelName') + '：'">
                        <Input v-model.trim="pageParams.shippingMethodName"></Input>
                      </Form-item>
                    </Col>
                    <Col span="5">
                      <Form-item :label="$t('logisticsProvider.channelNum') + '：'">
                        <Input v-model.trim="pageParams.shippingMethodCode"></Input>
                      </Form-item>
                    </Col>
                    <Col span='3' style="margin-left:62px;">
                      <Button type="primary" v-once icon="search" @click="search">{{$t('common.search')}}</Button>
                    </Col>
                  </Row>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <!--操作区-->
      <div class="addCanal">
        <Button type="primary" @click="addCanalFn" icon="plus">{{ $t('logisticsProvider.addCanal') }}</Button>
        <Button type="primary" icon="ios-upload-outline" @click="showImportExcelModal">{{ $t('common.batchImport') }}</Button>
      </div>
      <!-- 列表 -->
      <div class="orderTable normalTop">
        <Table highlight-row border :columns="canalColumns" :height="tableHeight" :data="canalData"></Table>
        <div class="table-page">
          <div class="table-page-right">
            <Page :total="total" @on-change="changePage" show-total :page-size="pageParams.pageSize" show-elevator :current="pageParams.pageNum" show-sizer @on-page-size-change="changePageSize" placement="top" :page-size-opts="pageArray"></Page>
          </div>
        </div>
      </div>
    </div>
    <Modal v-if="excelModalStatus" v-model="excelModal" transfer :mask-closable="false" @on-cancel="cancelUploadExcel">
        <p slot="header">
          <span>{{$t('logisticsProvider.loadExcelShippingMethod')}}</span>
        </p>
        <Form ref="modelParams" :model="modelParams" label-position="left">
          <FormItem :label="$t('logisticsProvider.downloadExcel') + '：'" :label-width="80">
            <a @click="downLoadExcelFiles" class="blurColor">{{$t('logisticsProvider.downloadExcel')}}</a>
          </FormItem>
          <FormItem :label="$t('logisticsProvider.selectExcel') + '：'">
            <Upload
              v-if="uploadPath && uploadHeader.hasOwnProperty('Authorization')"
              :action="uploadPath"
              :show-upload-list="false"
              :data="modelParams"
              ref="uploadFiles"
              name="file"
              :format="['xlsx', 'xls']"
              :before-upload="handleBeforeUpload"
              :headers="uploadHeader"
              :on-success="uploadSuccess"
              :on-error="uploadError"
              :on-format-error="handleFormatError"
              >
              <Button type="primary" class="normalRMargin">{{$t('common.selectFile')}}</Button>
            </Upload>
            <div v-if="file !== null" class="blurColor">{{file.name}}</div>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button @click="cancelUploadExcel">{{$t('common.cancel')}}</Button>
          <Button type="primary" :loading="uploadLoading" @click="confirmUploadExcel">{{$t('common.startUpload')}}</Button>
        </div>
      </Modal>
    <!-- 新增和编辑渠道 -->
    <canalDetail :shippingId="shippingId" :addFlag="addFlag" v-if="workShow === 'detail'"></canalDetail>
  </div>
</template>
<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
import tableMixin from '@/components/mixin/table_mixin';
import canalDetail from './channelManagementDetail';
export default {
  mixins: [ Mixin, tableMixin ],
  components: {
    canalDetail
  },
  data () {
    let self = this;
    return {
      workShow: 'list',
      addFlag: '', // 新增标识
      excelModal: false,
      excelModalStatus: false,
      modelParams: {
        carrierId: '',
        carrierType: '0'
      },
      uploadPath: api.upload_shippingMethod,
      uploadHeader: {
        'Authorization': sessionStorage.getItem('token')
      },
      file: null,
      uploadLoading: false, // 开始上传加载
      shippingId: '',
      pageParamsStatus: false, // 每次更新完pageParms都要设置成true触发刷新
      pageParams: {
        isValid: null, // 启用状态（选全部传空，1：是，0：否）
        checkStatus: null, // 是否审核通过（0-未通过1-通过）
        logisType: null, // 物流类型（选全部传空，1平邮,2挂号,3专线,4商业快递,5FBA头程）
        pageNum: 1,
        pageSize: 10,
        shippingMethodName: null, // 渠道名称
        shippingMethodCode: null
      },
      isValidList: [ // 状态
        {
          title: self.t('common.all'),
          id: null,
          selected: true
        },
        {
          title: self.t('common.status1'),
          id: 1,
          selected: false
        },
        {
          title: self.t('common.status0'),
          id: 0,
          selected: false
        },
        {
          title: self.t('common.checkstatus0'),
          id: 2,
          selected: false
        }
      ],
      channelTypeList: [ // 类型
        {
          title: self.t('common.all'),
          id: null,
          selected: true
        },
        {
          title: self.t('common.logisType1'),
          id: 1,
          selected: false
        },
        {
          title: self.t('common.logisType2'),
          id: 2,
          selected: false
        },
        {
          title: self.t('common.logisType3'),
          id: 3,
          selected: false
        },
        {
          title: self.t('common.logisType4'),
          id: 4,
          selected: false
        },
        {
          title: self.t('common.logisType5'),
          id: 5,
          selected: false
        }
      ],
      canalColumns: [
        {
          title: self.t('common.serialNum'),
          type: 'index',
          width: 70,
          fixed: 'left',
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.channelName'),
          key: 'shippingMethodName',
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.channelNum'),
          key: 'shippingMethodCode',
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.shippingCompanyId'),
          key: 'shippingCompanyId',
          minWidth: 150,
          width: 180,
          align: 'center'
        },
        {
          title: self.t('common.channelTypes'),
          key: 'logisType',
          align: 'center',
          render: (h, params) => {
            if (params.row.logisType === 1) {
              return h('span', self.t('common.logisType1'));
            } else if (params.row.logisType === 2) {
              return h('span', self.t('common.logisType2'));
            } else if (params.row.logisType === 3) {
              return h('span', self.t('common.logisType3'));
            } else if (params.row.logisType === 4) {
              return h('span', self.t('common.logisType4'));
            } else if (params.row.logisType === 5) {
              return h('span', self.t('common.logisType5'));
            }
          }
        },
        {
          title: self.t('logisticsProvider.expectTime'),
          key: 'expectedTime',
          align: 'center'
        },
        {
          title: self.t('common.status'),
          key: 'isValid',
          align: 'center',
          render (h, params) {
            return params.row.isValid === 1
              ? h('span', {
                style: {
                  color: '#3cb034'
                }
              }, self.t('common.status1'))
              : h('span', {
                style: {
                  color: '#de2910'
                }
              }, self.t('common.status0'));
          }
        },
        {
          title: self.t('common.checkStatus'),
          key: 'checkStatus',
          align: 'center',
          render (h, params) {
            return params.row.checkStatus === 1
              ? h('span', {
                style: {
                  color: '#3cb034'
                }
              }, self.t('common.checkstatus1')
              )
              : h('span', {
                style: {
                  color: '#de2910'
                }
              }, self.t('common.checkstatus0'));
          }
        },
        {
          title: self.t('common.operation'),
          width: 150,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    self.shippingId = params.row.shippingMethodId; // 渠道ID
                    self.addFlag = 'edit';
                    self.workShow = 'detail';
                  }
                }
              }, self.t('common.edit')),
              params.row.isValid
                ? h('Button', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginLeft: '5px'
                  },
                  on: {
                    click: () => {
                      self.changeStatus(params.row.shippingMethodId, params.row.isValid);
                    }
                  }
                }, self.t('common.status0'))
                : h('Button', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginLeft: '5px'
                  },
                  on: {
                    click: () => {
                      self.changeStatus(params.row.shippingMethodId, params.row.isValid);
                    }
                  }
                }, self.t('common.status1'))
            ]);
          }
        }
      ],
      canalData: [],
      total: 0, // 总记录数
      canalDetailModal: false // 是否显示选择映射sku模态窗
    };
  },
  methods: {
    getIsValidStatus (index, id) { // 状态筛选
      let v = this;
      if (id === 2) {
        v.pageParams.checkStatus = 0;
        v.pageParams.isValid = null;
      } else {
        v.pageParams.checkStatus = null;
        v.pageParams.isValid = id;
      }

      v.isValidList.forEach((n, i) => {
        if (i === index) {
          n.selected = true;
        } else {
          n.selected = false;
        }
      });
      v.getList();
    },
    getchannelType (index, id) { // 类型筛选
      let v = this;
      v.pageParams.logisType = id;
      v.channelTypeList.forEach((n, i) => {
        if (i === index) {
          n.selected = true;
        } else {
          n.selected = false;
        }
      });
      v.getList();
    },
    search () { // 查询
      let v = this;
      v.pageParamsStatus = true;
      v.pageParams.pageNum = 1;
    },
    // 新增渠道
    addCanalFn () {
      let v = this;
      v.$nextTick(function () {
        v.shippingId = '';
        v.addFlag = 'add';
        v.workShow = 'detail';
      });
    },
    // 获取渠道列表数据
    getList () {
      let v = this;
      if (v.pageParams.shippingMethodName === '') {
        v.pageParams.shippingMethodName = null;
      }
      if (v.pageParams.shippingMethodCode === '') {
        v.pageParams.shippingMethodCode = null;
      }
      v.axios.post(api.get_shipListPage2ver, v.pageParams)
        .then(res => {
          if (res.data.code === 0) {
            v.canalData = res.data.datas.list;
            v.total = res.data.datas.total;
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    // 修改渠道状态
    changeStatus (shippingMethodId, isValid) {
      let v = this;
      if (isValid) {
        isValid = 0;
      } else {
        isValid = 1;
      }
      v.axios.post(api.edit_shipStatus2ver + '?shippingMethodId=' + shippingMethodId + '&isValid=' + isValid)
        .then(res => {
          if (res.data.code === 0) {
            v.pageParamsStatus = true;
            if (isValid === 1) {
              v.$Message.success(v.t('common.enableOk'));
            } else if (isValid === 0) {
              v.$Message.success(v.t('common.disableOk'));
            }
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    handleBeforeUpload (file) {
      let v = this;
      // console.log(file)
      if (file.name.indexOf('.html') !== -1 || file.name.indexOf('.htm') !== -1) {
        v.$Notice.warning({
          title: v.t('validValue.fileError'),
          desc: file.name + v.t('validValue.fileError') + ',' + v.t('common.pleaseSelect') + 'xlsx or xls'
        });
        return false;
      }
      v.file = file;
      return false;
    },
    uploadSuccess (response, file, fileList) {
      let v = this;
      if (response.code === 0) {
        v.$Message.success({
          content: v.t('logisticsProvider.importSuccess'),
          duration: 3
        });
      } else {
        v.showErrorInfoFn(response.code, response.message); // 错误提示方法
      }
      v.excelModal = false; // 模态框
      v.file = null;
      v.uploadLoading = false;
    },
    uploadError () {
      let v = this;
      v.$Message.error(v.t('common.operateFailMes'));
    },
    handleFormatError (file) {
      let v = this;
      v.$Notice.warning({
        title: v.t('validValue.fileError'),
        desc: file.name + v.t('validValue.fileError') + ',' + v.t('common.pleaseSelect') + 'xlsx or xls'
      });
      v.uploadLoading = false;
    },
    // 确认上传excel
    confirmUploadExcel () {
      let v = this;
      if (v.file === null) {
        v.$Message.error(v.t('error.selectModalFile'));
        v.excelModal = true;
        return;
      }
      v.uploadLoading = true; // 开始上传加载中
      v.$refs['uploadFiles'].post(v.file);
    },
    // 取消上传excel
    cancelUploadExcel () {
      let v = this;
      v.file = null;
      v.excelModal = false;
    },
    // 下载模板
    downLoadExcelFiles () {
      const relativePath = window.location.host + '/static/files/';
      let fileName = 'ShipingMethodModel.xlsx';
      window.location.href = '//' + relativePath + fileName;
    },
    // 显示导入模态框
    showImportExcelModal () {
      let v = this;
      v.excelModalStatus = true;
      v.$nextTick(function () {
        v.excelModal = true;
      });
    }
  },
  created () {
    let v = this;
    v.getList();
    v.tableHeight = v.getTableHeight(448);
  },
  watch: {
    pageParamsStatus (n) {
      let v = this;
      if (n) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/logisticsProvider/components/logisticsProvider/channelManagement.vue